/**
 * Table of Content button
 *
 * This component handles the visibility of the table of content button calculating the position of the scrolling
 */
document.addEventListener('alpine:init', () => {
    window.Alpine.data('tocButton', () => ({
        showButton: false,
        init() {
            let firstHeadline = document.querySelector('h1');
            let footerHeight = document.querySelector('footer').clientHeight;
            let documentHeight = document.querySelector('body').clientHeight;

            window.addEventListener('scroll', () => {
                this.showButton = window.helpers.scrolledOverH1Headline(firstHeadline, footerHeight, documentHeight);
            });
        },
    }));
});
